import {useState} from "react"
import {createModel} from "hox"

function useCurrentRobotInput(): [string, (param: string) => void] {
    const [value, setInputValue] = useState("")

    const setValue = (input: string) => {
        setInputValue(input.substring(0, 3000))
    }

    return [value, setValue]
}

export default createModel(useCurrentRobotInput)
